<template>
  <div class="batchBox">
    <div class="backBox">
      <span class="goback" @click="goToTable">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-fanhui"></use>
        </svg>
        返回</span>
    </div>
    <div style="margin-top: 20px;">
      <span class="formContent">
        <el-form ref="rowInfo" :model="rowInfo" :rules="rules" label-width="200px">
        <el-row><el-col><span style="font-weight: bold;margin-left:30px;"><i class="el-icon-menu"></i>基本信息</span></el-col></el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="姓名">
              <span style="width: 220px">{{rowInfo.driverName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="身份证号">
              <span style="width: 220px">{{rowInfo.idCard}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="性别">
               <span style="width: 220px">{{rowInfo.genderTxt}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
              <el-form-item label="电话">
                 <span style="width: 220px">{{rowInfo.phone}}</span>
              </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="加盟城市">
              <span style="width: 220px">{{rowInfo.joinCity}}</span>
            </el-form-item>
          </el-col>
         <el-col :span="8">
           <el-form-item label="加盟日期">
             <span style="width: 220px">{{rowInfo.joinDate}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="所属车队">
              <span style="width: 220px">{{rowInfo.company}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
           <el-form-item label="联系地址">
              <span style="width: 220px">{{rowInfo.address}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车牌号">
               <span style="width: 220px">{{rowInfo.plateNumber}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
           <el-form-item label="车型">
              <span style="width: 220px">{{rowInfo.vehicleBrand}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车辆颜色">
              <span style="width: 220px">{{rowInfo.vehicleColor}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
           <el-form-item label="备注">
                <span style="width: 220px">{{rowInfo.remark}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
           <el-col :span="8">
            <el-form-item label="身份证正面">
              <div class="imgbox">
                <img
                  v-if="rowInfo.idCardFrontUrl"
                  :src="rowInfo.idCardFrontUrl" @click="onPreview(rowInfo.idCardFrontUrl)">
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="驾驶证正面">
              <div class="imgbox" v-if="rowInfo.driverLicenseFrontUrl">
                <img :src="rowInfo.driverLicenseFrontUrl" @click="onPreview(rowInfo.driverLicenseFrontUrl)">
              </div>
            </el-form-item>
          </el-col>
         <!-- <el-col :span="12">
           <el-form-item label="驾驶证反面">
           <div class="imgbox">
              <img
                v-if="rowInfo.driverLicenseReverseUrl"
                :src="rowInfo.driverLicenseReverseUrl" @click="onPreview(rowInfo.driverLicenseReverseUrl)">
            </el-form-item>
            </div>
          </el-col>-->
           <el-col :span="8">
            <el-form-item label="行驶证正面">
              <div class="imgbox" v-if="rowInfo.drivingLicenseFrontUrl">
               <img :src="rowInfo.drivingLicenseFrontUrl"  @click="onPreview(rowInfo.drivingLicenseFrontUrl)">
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
           <el-form-item label="行驶证反面">
             <div class="imgbox" v-if="rowInfo.drivingLicenseReverseUrl">
             <img :src="rowInfo.drivingLicenseReverseUrl" @click="onPreview(rowInfo.drivingLicenseReverseUrl)">
             </div>
           </el-form-item>
          </el-col>
          <el-col :span="8">
           <el-form-item label="车辆照片">
             <div class="imgbox" v-if="rowInfo.vehiclePhotosUrl">
              <img :src="rowInfo.vehiclePhotosUrl" @click="onPreview(rowInfo.vehiclePhotosUrl)">
             </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row><el-col><span style="font-weight: bold;margin-left:30px;"><i class="el-icon-menu"></i>保单信息</span></el-col></el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="交强险">
              <p style="width: 220px"><span>保单到期日期：{{policyInfo.comInsuranceExpDate}}</span></p>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="交强险附件">
              <div class="imgbox" v-for="itemurl in policyInfo.comInsuranceAttachUrls" v-bind:key="itemurl">
                <img :src="itemurl" @click="onPreview(itemurl)">
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
        <el-col :span="8">
          <el-form-item label="商业险">
            <p style="display:flex;flex-direction: column;"><span>保单到期日期：{{policyInfo.busInsuranceExpDate}}</span></p>
            <p style="display:flex;flex-direction: column;"><span>是否有车损险：{{policyInfo.vehicleInsurance=='10060001'?'是':'否'}}</span> <!--<span v-if="policyInfo.vehicleInsurance=='10060001'">保额：{{policyInfo.vehicleInsuranceValue}}</span> --></p>
            <p style="display:flex;flex-direction: column;"><span>是否有第三者责任险：{{policyInfo.thirdInsurance=='10060001'?'是':'否'}}</span><span v-if="policyInfo.thirdInsurance=='10060001'">保额：{{policyInfo.thirdInsuranceValue/10000}}万</span></p>
            <p style="display:flex;flex-direction: column;"><span>是否有司乘险：{{policyInfo.driversInsurance=='10060001'?'是':'否'}}</span><span v-if="policyInfo.driversInsurance=='10060001'">保额：{{policyInfo.driversInsuranceValue/10000}}万</span></p>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="商业险附件">
            <div class="imgbox" v-for="itemurl in policyInfo.busInsuranceAttachUrls" v-bind:key="itemurl">
              <img :src="itemurl" @click="onPreview(itemurl)">
            </div>
          </el-form-item>
          </el-col>
        </el-row>
        </el-form>
    </span>
    <span slot="footer" class="footer">
        <el-button type="primary" v-if="rowInfo.approvalStatus=='10020001'" size="mini" @click="agree">同意</el-button>
        <el-button type="danger" v-if="rowInfo.approvalStatus=='10020001'" size="mini" @click="turnDown">驳回</el-button>
        <el-button size="mini"  @click="goToTable">返回</el-button>
    </span>
    </div>
    <div>
      <el-image-viewer
        v-if="showViewer"
        :on-close="closeViewer"
        :url-list="srcList" />
    </div>
    <!--弹出内容-->
    <turn-down v-if="showVisible" ref="turnDown" @refresh="goToTable"/>
  </div>
</template>
<script>
  // 导入组件
  import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
  import { addListpage, getDynamicFormValue } from  "@/api/driver/driverinfo"
  import turnDown from './turndown'
  export default {
    components: { ElImageViewer,turnDown },
    data() {
      return {
        showVisible: false,
        showViewer: false, // 显示查看器
        activeIndex: 0,
        id: '',
        title: '详情',
        rowInfo: {
        },
        policyInfo:{},//保单信息
        srcList:[],
        oldSrcList:[] //记录原始顺序
      }
    },
    mounted() {
      // 加载参数
      this.id = this.$route.query.id
      this.initData(this.id);
    },
    methods: {
      initData(id) {
        if (id) {
          getDynamicFormValue(id).then((res) => {
            if(res.data.code==0){
              let data = res.data
              this.rowInfo = data.data
              if(this.rowInfo.idCardFrontUrl){
                this.$set(this.rowInfo,'idCardFrontUrl', process.env.VUE_APP_BASE_API +''+ this.rowInfo.idCardFrontUrl)
                this.srcList.push(this.rowInfo.idCardFrontUrl);
              }
              if(this.rowInfo.idCardReverseUrl){
                this.$set(this.rowInfo,'idCardReverseUrl', process.env.VUE_APP_BASE_API +''+ this.rowInfo.idCardReverseUrl)
                this.srcList.push(this.rowInfo.idCardReverseUrl);
              }
              if(this.rowInfo.driverLicenseFrontUrl){
                this.$set(this.rowInfo,'driverLicenseFrontUrl', process.env.VUE_APP_BASE_API +''+ this.rowInfo.driverLicenseFrontUrl)
                this.srcList.push(this.rowInfo.driverLicenseFrontUrl);
              }
              if(this.rowInfo.driverLicenseReverseUrl){
                this.$set(this.rowInfo,'driverLicenseReverseUrl', process.env.VUE_APP_BASE_API +''+ this.rowInfo.driverLicenseReverseUrl)
                this.srcList.push(this.rowInfo.driverLicenseReverseUrl);
              }
              if(this.rowInfo.drivingLicenseFrontUrl){
                this.$set(this.rowInfo,'drivingLicenseFrontUrl', process.env.VUE_APP_BASE_API +''+ this.rowInfo.drivingLicenseFrontUrl)
                this.srcList.push(this.rowInfo.drivingLicenseFrontUrl);
              }
              if(this.rowInfo.drivingLicenseReverseUrl){
                this.$set(this.rowInfo,'drivingLicenseReverseUrl', process.env.VUE_APP_BASE_API +''+ this.rowInfo.drivingLicenseReverseUrl)
                this.srcList.push(this.rowInfo.drivingLicenseReverseUrl);
              }
              if(this.rowInfo.vehiclePhotosUrl){
                this.$set(this.rowInfo,'vehiclePhotosUrl', process.env.VUE_APP_BASE_API +''+ this.rowInfo.vehiclePhotosUrl)
                this.srcList.push(this.rowInfo.vehiclePhotosUrl);
              }

              //保单信息
              if(this.rowInfo.policyInfo){
                this.policyInfo = this.rowInfo.policyInfo
                if(this.policyInfo.comInsuranceAttachUrls){
                    var newComUrls = [];
                    this.policyInfo.comInsuranceAttachUrls.forEach(item =>{
                        item = process.env.VUE_APP_BASE_API+item;
                        newComUrls.push(item);
                        this.srcList.push(item);
                    })
                    this.$set(this.policyInfo,'comInsuranceAttachUrls',newComUrls);
                }
                  if(this.policyInfo.busInsuranceAttachUrls){
                      var newComUrls = [];
                      this.policyInfo.busInsuranceAttachUrls.forEach(item =>{
                          item = process.env.VUE_APP_BASE_API+item;
                          newComUrls.push(item);
                          this.srcList.push(item);
                      })
                      this.$set(this.policyInfo,'busInsuranceAttachUrls',newComUrls);
                  }
              }
              this.oldSrcList = this.srcList;
            }
          })
        }
      },
      //通过
      agree(){
        let obj = {};
        obj.id = this.rowInfo.id;
        obj.approvalStatus = '10020002';
        this.$confirm("确定同意该司机的申请吗？", '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          addListpage(obj).then((res) => {
            this.$message.success("审核成功")
            this.goToTable()
          })
        })
      },
      //驳回
      turnDown(){
        this.showVisible = true
        this.$nextTick(() => {
          this.$refs.turnDown.init(this.rowInfo.id)
        })
      },
      onPreview(url) {
        this.showViewer = true
        let tempImgList = [];//所有图片地址
        this.oldSrcList.map(item=>{
          tempImgList.push(item);
        });
        let temp = [];
        for (let i = 0; i < tempImgList.length; i++) {
          if(tempImgList[i]==url){
            temp = tempImgList.splice(0,i);
          }
        }
        this.srcList = tempImgList.concat(temp);//将当前图片调整成点击缩略图的那张图片
      },
      // 关闭查看器
      closeViewer() {
        this.showViewer = false
      },
      goToTable() {
        // 返回数据页面
       // this.$router.go(-1)
        this.$router.push({
          path: '/driver/manage',
        })
      }
    }
  }
</script>
<style scoped  rel="stylesheet/scss">
  .backBox{
    /*margin-bottom: 20px;*/
  }
  .goback{
    width: 70px;
    padding:8px;
    border:1px solid #cccccc;
    color:#cccccc;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    line-height: 16px;
    font-size: 14px;
    cursor: pointer;
  }
  .goback:hover{
    border:1px solid #269cff;
    color:#269cff;
  }
  .batchBoxTitle{
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    line-height: 40px;
  }
  .footer{
    position: fixed;
    bottom: 10px;
    left: 50%;
  }
  .imgbox{
    width: 100px;
    height: 100px;
    background: #7a7777;
    float: left;
    margin-right: 5px;
  }
  .imgbox img{
    width: 100px;
    max-height: 100px;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }

</style>
